import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { createContext } from '../../utils/react-helpers.esm.js';

var _createContext = createContext({
    strict: false,
    name: 'ContainerContext'
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  ContainerContextProvider = _createContext2[0],
  useContainerContext = _createContext2[1];

export { ContainerContextProvider, useContainerContext };
//# sourceMappingURL=container-context.esm.js.map
